import React, { useState } from 'react';
import { House } from '@phosphor-icons/react';
interface OfferListingPreviewProps {
  image?: string;
  title: string;
  priceLabel: string;
  locationLabel: string;
  url: string;
}
export function OfferListingPreview({
  image,
  title,
  priceLabel,
  locationLabel,
  url
}: OfferListingPreviewProps) {
  const [imgError, setImgError] = useState(false);
  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    window.open(url, '_blank', 'noopener');
  };
  // Extract domain for display
  let domain = '';
  try {
    domain = new URL(url).hostname.replace('www.', '');
  } catch {
    domain = url;
  }
  const showImage = image && !imgError;
  return <button onClick={handleClick} className="w-full text-left flex items-center gap-4 p-3 rounded-xl bg-dark-3 border border-dark-4 hover:border-light-4 transition-colors cursor-pointer group" data-id="element-631">
      {showImage ? <img src={image} alt={title} onError={() => setImgError(true)} className="w-20 h-20 sm:w-24 sm:h-24 rounded-lg object-cover shrink-0" data-id="element-632" /> : <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-lg bg-dark-4 flex items-center justify-center shrink-0" data-id="element-633">
          <House size={28} className="text-light-4" weight="duotone" data-id="element-634" />
        </div>}

      <div className="min-w-0 flex-1" data-id="element-635">
        <h4 className="text-sm font-semibold text-light-1 truncate group-hover:underline" data-id="element-636">
          {title}
        </h4>
        <div className="flex items-center gap-2 mt-1 text-xs text-light-2" data-id="element-637">
          <span className="font-medium" data-id="element-638">{priceLabel}</span>
          <span className="text-light-4" data-id="element-639">·</span>
          <span className="truncate" data-id="element-640">{locationLabel}</span>
        </div>
        <div className="mt-1.5 text-[10px] text-light-4 uppercase tracking-wider" data-id="element-641">
          {domain}
        </div>
      </div>
    </button>;
}